module.exports = __webpack_public_path__ + "img/37c80f0.png";